import React from "react";

// components

import CompaniesTable from "components/Cards/CompaniesTable";

export default function Companies() {
  return (
    <>
      <div className="flex flex-wrap">
        <CompaniesTable />
      </div>
    </>
  );
}
